import { makeStyles, Theme } from '@material-ui/core/styles';
import Image from '../../assets/Patterns.png';

export const useStyles = makeStyles((theme: Theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(1),
    background: `url(${Image}), linear-gradient(180deg, #FFFFFF -30.28%, #E2E6F7 161.33%)`,
    backgroundPosition: 'bottom, left top',
    backgroundRepeat: 'repeat-x, repeat',
    backgroundSize: 'contain, cover',
    minHeight: 'calc(100vh - 106px)',
  },
  topBar: {
    display: 'flex',
    alignItems: 'center',
    height: '106px',
    backgroundColor: '#ffffff',
    borderBottom: '1px solid #E0E0E0',
  },
  heading: {
    fontWeight: 700,
    fontSize: '24px',
    lineHeight: '123.5%',
    textAlign: 'center',
    letterSpacing: '0.25px',
    color: '#363473',
    marginTop: 42,
  },
  detail: {
    fontWeight: 400,
    fontSize: '24px',
    lineHeight: '123.5%',
    textAlign: 'center',
    letterSpacing: '0.25px',
    color: '#636371',
    marginTop: 12,
  },
  paper: {
    // marginTop: '80px',
    width: 500,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '40px',
    boxShadow: 'none',
    // '@media (min-height: 768px)': {
    //   marginTop: 'calc(50vh - 350px)',
    // },
  },
  button: {
    width: '100%',
    marginTop: '20px',
    boxShadow: 'none',
    lineHeight: '36px',
    padding: `8px 22px`,
    backgroundColor: '#E2222B',
    textTransform: 'uppercase',
  },
}));
